import React, { useContext, useState } from 'react'
import { Button, Card, Col, Descriptions, Divider, Input, Popconfirm, Popover, Row, Table } from 'antd'
import RightOutlined from '@ant-design/icons/lib/icons/RightOutlined'
import DownOutlined from '@ant-design/icons/lib/icons/DownOutlined'
import SearchOutlined from '@ant-design/icons/lib/icons/SearchOutlined'
import MoreOutlined from '@ant-design/icons/lib/icons/MoreOutlined'
import { Context, useStore } from '../../../../context'

const { Search } = Input

function ProductTabTable(props) {
  const [state] = useContext(Context)
  const { hasPermissions } = useStore(state)
  const [expended, setExpended] = useState()

  const pluck = (arr, key) => arr.map(i => i[key]);

  const expend = (e) => {
    if (expended === e.key) setExpended(undefined);
    else setExpended(e.key);
  };

  const getFilteredData = data => {
    props.handlerTextSearch(data)
  }

  const columns = [
    {
      title: 'Lista de productos',
      dataIndex: 'productDescription', // Field that is goint to be rendered
      key: 'productDescription',
      align: 'left',
      render: (text, e) => <span onClick={() => expend(e)}>{text}</span>,
    },
    // {
    //   title: 'Nombre de empresa',
    //   dataIndex: 'company_name', // Field that is goint to be rendered
    //   key: 'company_name',
    //   align: 'left',
    //   render: (text, e) => <span onClick={() => expend(e)}>{text}</span>,
    // },
    {
      align: 'right',
      title: '',
      dataIndex: '_id', // Field that is goint to be rendered
      key: '_id',
      render: (row, data) => (
        <span>
          <Popover
            placement="left"
            content={
              <div>
                {hasPermissions([23]) && (
                  <span className={'user-options-items'} onClick={() => props.handlerEditRow(data)}>
                    Editar
                  </span>
                )}
                {hasPermissions([23]) && hasPermissions([24]) && <Divider className={'divider-enterprise-margins'} type={'horizontal'} />}
                {hasPermissions([24]) && (
                  <Popconfirm
                    title="¿Estás seguro de eliminar el elemento selccionado?"
                    onConfirm={() => props.handlerDeleteRow(data)}
                    okText="Sí"
                    cancelText="No"
                  >
                    <span className={'user-options-items'}>Eliminar</span>
                  </Popconfirm>
                )}
              </div>
            }
            trigger="click"
          >
            {(hasPermissions([23]) || hasPermissions([24])) && (
              <Button shape={'circle'} className={'enterprise-settings-button'}>
                <MoreOutlined />
              </Button>
            )}
          </Popover>
        </span>
      ),
    },
  ]

  return (
    <>
      <Row>
        <Col xs={24} sm={24} md={18} lg={14}>
          <Search
            prefix={<SearchOutlined className={'tendero-table-search-icon'} />}
            placeholder="Buscar"
            style={{ width: '70%', height: '40px' }}
            size={'large'}
            onSearch={e => getFilteredData(e)}
          />
        </Col>
        <Col xs={24} sm={24} md={6} lg={10} className="product-header-elements-container">
          {hasPermissions([22]) &&
            (state.auth.company?.allow_add_products !== undefined ? (state.auth.company?.allow_add_products === 1 ? true : false) : true) && (
              <Button className="title-tendero new-button product-margin-header-button" onClick={props.handlerShowDrawer}>
                Nuevo producto
              </Button>
            )}
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card className={'card-border-radius margin-top-15'}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Table
                  loading={props.loading}
                  className={'CustomTableClass CustomTableClassProduct'}
                  expandedRowKeys={[expended]}
                  dataSource={props.dataSource}
                  columns={columns}
                  pagination={false}
                  rowKey="key"
                  expandable={{
                    rowExpandable: record => record.productDescription !== null,
                    expandRowByClick: true,
                    expandedRowRender: record => (
                      <Descriptions bordered size="small" column={{ xs: 1, sm: 2, md: 3 }} className={'product-detail-descriptions'}>
                        <Descriptions.Item label="Cadena">{record.all_chains}</Descriptions.Item>
                        <Descriptions.Item label="Países donde aplica">{record.all_countries}</Descriptions.Item>
                        <Descriptions.Item label="Marca">{record.brand_name}</Descriptions.Item>
                        <Descriptions.Item label="Categoría">{record.product_category.name}</Descriptions.Item>
                        <Descriptions.Item label="Departamento">{record.product_department.name}</Descriptions.Item>
                        <Descriptions.Item label="Subcategoría">{record.product_subcategory.name}</Descriptions.Item>
                        <Descriptions.Item label="Exento de impuestos">{record.is_taxable === 1 ? 'Sí' : 'No'}</Descriptions.Item>
                        <Descriptions.Item label="¿Impacta inventario?">{record.is_inventoriable === 1 ? 'Sí' : 'No'}</Descriptions.Item>
                        <Descriptions.Item label="Expresión mínima">{record.minimal_expresion}</Descriptions.Item>
                        <Descriptions.Item label="Precio sugerido">{record.suggested_price}</Descriptions.Item>
                        <Descriptions.Item label="Principio Activo 1">{record.product_active_principle_1}</Descriptions.Item>
                        <Descriptions.Item label="Principio Activo 2">{record.product_active_principle_2}</Descriptions.Item>
                        <Descriptions.Item label="Principio Activo 3">{record.product_active_principle_3}</Descriptions.Item>
                      </Descriptions>
                    ),
                    expandIcon: ({ expanded, record }) =>
                      (expanded ? <DownOutlined onClick={() => expend(record)} /> : <RightOutlined onClick={() => expend(record)} />),
                  }}
                />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default ProductTabTable
